import { Action, Thunk, action, thunk } from 'easy-peasy';
import React from 'react';

export interface demo {
  contact: object;
  setContact: Action<demo, any>;
  postContact: Thunk<demo, any>;
}

const DemoModel: demo = {
  contact: {},

  setContact: action((state, payload: any) => {
    state.contact = payload;
  }),

  postContact: thunk((action, payload) => {
    action.setContact(payload);
  }),
};

export default DemoModel;
